import { Teksten } from "../../../content";
import { Velden } from "../../../models/document-metadata";
import { ContainerAtom, SpacerAtom } from "../../atoms";
import { IconButtonMolecule } from "../button";
import { TextInputMolecule } from "../text-input";
import styles from "./styles.module.scss";

interface Props {
  onChange: (velden: Velden[]) => void;
  value: Velden[];
  disabled?: boolean;
  inputRef?: (ref: HTMLInputElement) => void;
}

export function NaamWaardeInputfieldMolecule(props: Readonly<Props>) {
  const updateKey = (index: number, tekst?: string) => {
    let nieuweWaardes: Velden[] = JSON.parse(JSON.stringify(props.value));
    if (tekst) nieuweWaardes[index].key = tekst;
    else if (props.value.length === 1) nieuweWaardes = [];
    else nieuweWaardes.splice(index, 1);
    props.onChange(nieuweWaardes);
  };

  const updateValue = (keyIndex: number, valueIndex: number, tekst: string | undefined) => {
    let nieuweWaardes: Velden[] = JSON.parse(JSON.stringify(props.value));
    if (tekst === undefined) nieuweWaardes[keyIndex].values?.splice(valueIndex, 1);
    else nieuweWaardes[keyIndex].values![valueIndex] = tekst;

    props.onChange(nieuweWaardes);
  };

  const keyValue = (keyValue: Velden, index: number) => {
    return (
      <ContainerAtom type="row">
        <TextInputMolecule
          disabled={props.disabled}
          inputRef={props.inputRef}
          key={Teksten.createScreen.naam.id}
          id={Teksten.createScreen.naam.id + "_" + index}
          label={index === 0 ? Teksten.createScreen.naam.label : undefined}
          tooltip={Teksten.createScreen.naam.tooltip}
          placeholder={Teksten.createScreen.naam.placeholder}
          onChange={(value: string) => updateKey(index, value)}
          value={keyValue.key}
        />
        <ContainerAtom type="flex">
          {keyValue.values?.map((value: string, valueIndex: number) => {
            return (
              <>
                <ContainerAtom type="row">
                  <TextInputMolecule
                    disabled={props.disabled}
                    inputRef={props.inputRef}
                    key={Teksten.createScreen.waarde.id}
                    id={Teksten.createScreen.waarde.id + "_" + index + "_" + valueIndex}
                    label={valueIndex === 0 && index === 0 ? Teksten.createScreen.waarde.label : undefined}
                    placeholder={Teksten.createScreen.waarde.placeholder}
                    onChange={(value: string) => updateValue(index, valueIndex, value)}
                    value={value}
                  />
                  <div style={{ maxWidth: "min-content", alignSelf: "end" }}>
                    <IconButtonMolecule
                      id={"verwijder_value"}
                      title={"Verwijder value"}
                      icon={"icon-remove-blue"}
                      type={"default"}
                      size={"inputfieldSize"}
                      disabled={props.disabled}
                      onClick={() => {
                        if (keyValue.values!.length > 1) updateValue(index, valueIndex, undefined);
                        else updateKey(index);
                      }}
                    />
                  </div>
                </ContainerAtom>
                <SpacerAtom space={2} />
              </>
            );
          })}

          {index < props.value.length - 1 && (
            <>
              <div className={styles.marginRight}>
                <IconButtonMolecule
                  disabled={props.disabled}
                  text="Voeg value toe"
                  title="Voeg een extra value toe"
                  icon={"icon-plus-shape"}
                  id={"add_value_button"}
                  type={"blue"}
                  size={"medium"}
                  onClick={() => updateValue(index, keyValue.values!.length, "")}
                />
              </div>
              <SpacerAtom space={4} />
            </>
          )}
        </ContainerAtom>
      </ContainerAtom>
    );
  };

  return (
    <>
      <ContainerAtom>{props.value?.map((velden: Velden, index: number) => keyValue(velden, index))}</ContainerAtom>
      <ContainerAtom type="row">
        <div>
          <IconButtonMolecule
            disabled={props.disabled}
            text="Voeg key-value paar toe"
            title="Voeg een extra key-value paar toe"
            icon={"icon-plus-shape"}
            id={"add_key-value_button"}
            type={"blue"}
            size={"medium"}
            onClick={() => props.onChange([...props.value, { key: "", values: [""] }])}
          />
        </div>
        <div>
          <div className={styles.marginRight}>
            <IconButtonMolecule
              disabled={props.disabled}
              text="Voeg value toe"
              title="Voeg een extra value toe"
              icon={"icon-plus-shape"}
              id={"add_value_button"}
              type={"blue"}
              size={"medium"}
              onClick={() => updateValue(props.value.length - 1, props.value.at(-1)!.values!.length, "")}
            />
          </div>
        </div>
      </ContainerAtom>
    </>
  );
}
